var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9999 6L2.7819 6.813C1.9079 7.395 1.4709 7.686 1.2339 8.13C0.996897 8.575 0.998897 9.097 1.0029 10.14C1.0069 11.398 1.0189 12.678 1.0509 13.974C1.1279 17.049 1.1659 18.586 2.2969 19.716C3.4269 20.846 4.9849 20.886 8.1009 20.964C10.0336 21.0123 11.9672 21.0123 13.8999 20.964C17.0159 20.886 18.5739 20.847 19.7039 19.716C20.8339 18.586 20.8729 17.049 20.9499 13.974C20.9819 12.678 20.9939 11.398 20.9979 10.141C21.0009 9.097 21.0029 8.575 20.7659 8.131C20.5299 7.686 20.0929 7.395 19.2189 6.813L17.9999 6",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9L7.913 13.148C9.417 14.05 10.169 14.5 11 14.5C11.831 14.5 12.583 14.05 14.087 13.147L21 9",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 11V5C4 3.114 4 2.172 4.586 1.586C5.172 1 6.114 1 8 1H14C15.886 1 16.828 1 17.414 1.586C18 2.172 18 3.114 18 5V11M9 9H13M9 5H13",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadMessage);
export default __webpack_public_path__ + "static/media/ReadMessage.b03264c6f60fd0117eaa671d5f11501f.svg";
export { ForwardRef as ReactComponent };